<p-card>
    <p-table [value]="retestList" [tableStyle]="{'min-width': '50rem'}" #dt
        [rows]="50" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
        [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [columns]="cols"
        stateStorage="local" stateKey="retestlist-state">
        <ng-template pTemplate="header">
            <tr> 
                <th pSortableColumn="barcode" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Barcode
                        <p-sortIcon field="barcode"></p-sortIcon>
                        <p-columnFilter type="date" field="barcode" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="type" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Type
                        <p-sortIcon field="type"></p-sortIcon>
                        <p-columnFilter type="text" field="type" display="menu"></p-columnFilter>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pendingretest>
            <tr>
                <td>{{pendingretest.barcode}}</td>
                <td>{{pendingretest.type}}</td>
            </tr>
        </ng-template>
    </p-table>
</p-card>